// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Move from "@insite/mobius/Icons/Move";
import { LinkPresentationProps, StyledIcon } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { productListStyles } from "@steiner/Overrides/Widgets/MyListsDetails/MyListsDetailsProductList";
import List from "@steiner/XDL/Icons/List";
import Table from "@steiner/XDL/Icons/Table";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

interface ViewsSharedStyles {
    viewText?: TypographyPresentationProps;
    viewsContainer?: InjectableCss;
    listViewLink?: LinkPresentationProps;
    tableViewLink?: LinkPresentationProps;
}

export const viewsSharedStyles: ViewsSharedStyles = {
    viewText: { size: fontConfig.fontSize.small, lineHeight: fontConfig.lineHeight.small },
    viewsContainer: {
        css: css`
            display: flex;
            gap: 8px;
            justify-content: flex-end;
            border-bottom: 1px solid ${color("primary")};
            padding-bottom: 12px;

            @media print {
                display: none;
            }
        `,
    },
    listViewLink: {
        icon: {
            position: "left",
            iconProps: {
                src: List,
                size: 21,
                css: css`
                    margin-right: 0;
                `,
            },
        },
        css: css`
            ${({ active }: any) =>
                active
                    ? css`
                          ${StyledIcon} {
                              color: ${color("primary")};
                          }
                      `
                    : css`
                          ${StyledIcon} {
                              color: ${color("common.ui4")};
                          }
                      `}
        `,
    },
    tableViewLink: {
        icon: {
            position: "left",
            iconProps: {
                src: Table,
                size: 21,
                css: css`
                    margin-right: 0;
                `,
            },
        },
        css: css`
            ${({ active }: any) =>
                active
                    ? css`
                          ${StyledIcon} {
                              color: ${color("primary")};
                          }
                      `
                    : css`
                          ${StyledIcon} {
                              color: ${color("common.ui4")};
                          }
                      `}
        `,
    },
};

productListStyles.messageText = {
    css: css`
        margin: 10px 0 auto;
    `,
};

productListStyles.basicContainer = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

productListStyles.viewText = {
    ...viewsSharedStyles.viewText,
};

productListStyles.viewsContainer = {
    ...viewsSharedStyles.viewsContainer,
};

productListStyles.listViewLink = {
    ...viewsSharedStyles.listViewLink,
};

productListStyles.tableViewLink = {
    ...viewsSharedStyles.tableViewLink,
};

productListStyles.container = {
    gap: 0,
};

productListStyles.sortOrderTextField = {
    labelPosition: "top",
    labelProps: {
        transform: "uppercase",
        size: 9,
        css: css`
            text-align: center;
        `,
    },
    cssOverrides: {
        inputSelect: css`
            text-align: center;
            max-width: 60px;
        `,
    },
};

productListStyles.dragHandleIcon = {
    src: Move,
    size: 18,
    css: css`
        cursor: move;
    `,
};

productListStyles.deleteLineModalStyles = {
    submitButton: {
        color: "primary",
    },
};
